import React from "react";
import { Panel } from "@xyflow/react";
import { Button, XClose } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "../CustomCampaignShowContainer";
import TriggerNodeForm from "./TriggerNodeForm";
import TimeDelayNodeForm from "./TimeDelayNodeForm";
import WaitUntilNodeForm from "./WaitUntilNodeForm";
import SendBetweenNodeForm from "./SendBetweenNodeForm";
import EmailNodeForm from "./EmailNodeForm";
import SmsNodeForm from "./SmsNodeForm";
import TrueFalseBranchNodeForm from "./TrueFalseBranchNodeForm";
import { NODE_ICONS } from "./nodeIcons";

const panelStyle = {
  maxHeight: "90%",
  overflow: "auto",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  borderRadius: 12,
  border: "1px solid var(--sl-border-secondary)",
  maxWidth: "calc(100vw - 32px)",
};

const sidebarStyle = {
  minWidth: 200,
  maxWidth: 520,
  padding: 20,
  width: "fit-content",
  height: "fit-content",
  backgroundColor: "var(--sl-bg-primary)",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  color: "var(--sl-text-primary)",
};

const headerContainerStyle = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "space-between",
  width: "100%",
  gap: 12,
  marginBottom: 20,
};

const iconBoxStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  borderRadius: 8,
  border: "1px solid var(--sl-border-secondary)",
  color: "var(--sl-text-secondary)",
};

const titleStyle = {
  fontSize: 18,
  fontWeight: 600,
  lineHeight: "28px",
  color: "var(--sl-text-primary)",
};

const subtitleStyle = {
  fontSize: 14,
  lineHeight: "20px",
  color: "var(--sl-text-tertiary)",
};

export default ({ handleUpdateNode }) => {
  const {
    selectedNode,
    setSelectedNode,
    saveDisabled,
    saving,
  } = useCustomCampaignShowContext();

  const nodeType = selectedNode?.type;
  const NodeIcon = NODE_ICONS[nodeType];
  const handleSave = handleUpdateNode || (() => {});

  return (
    <Panel position="top-right" style={panelStyle}>
      <div style={sidebarStyle}>
        <div style={headerContainerStyle}>
          <div style={{ display: "flex", gap: 12 }}>
            {NodeIcon ? (
              <div style={iconBoxStyle}>
                <NodeIcon width={20} height={20} aria-hidden="true" />
              </div>
            ) : null}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={titleStyle}>{selectedNode?.title}</div>
              {nodeType === "WorkflowNodes::TriggerNode" ? (
                <div style={subtitleStyle}>Triggers specify when an automation starts</div>
              ) : null}
            </div>
          </div>
          <Button variant="tertiary" size="sm" icon={XClose} aria-label="Close" onClick={() => setSelectedNode(null)} />
        </div>
        <form style={{ width: "100%" }} onSubmit={(e) => e.preventDefault()}>
          {
            nodeType === "WorkflowNodes::TriggerNode" ? <TriggerNodeForm /> :
            nodeType === "WorkflowNodes::TimeDelayNode" ? <TimeDelayNodeForm /> :
            nodeType === "WorkflowNodes::WaitUntilNode" ? <WaitUntilNodeForm /> :
            nodeType === "WorkflowNodes::SendBetweenNode" ? <SendBetweenNodeForm /> :
            nodeType === "WorkflowNodes::EmailNode" ? <EmailNodeForm /> :
            nodeType === "WorkflowNodes::SmsNode" ? <SmsNodeForm /> :
            nodeType === "WorkflowNodes::TrueFalseBranchNode" ? <TrueFalseBranchNodeForm /> :
            <div style={subtitleStyle}>Form Body</div>
          }
        </form>
        <Button
          variant="primary"
          disabled={saveDisabled || saving}
          onClick={() => handleSave()}
          style={{ width: "100%", marginTop: 20 }}
        >
          {saving ? "Saving..." : "Save"}
        </Button>
      </div>
    </Panel>
  );
};
